/* eslint-disable indent */

'use client';

import { useQuery, UseQueryOptions, QueryKey } from '@tanstack/react-query';

import { IApiError } from '@northladder/utilities';

import { useAuthStore, useRegionStore } from '../../stores';

/**
 * `useQueryWithUserId` is a copy of reactQuery useQuery function with custom userId
 * for session api, state, cache management
 * https://tanstack.com/query/latest/docs/framework/react/guides/queries
 */
export const useQueryWithUserId = <
  TQueryFnData = unknown,
  TError = IApiError | null,
  TData = TQueryFnData
>({
  queryKey = [],
  ...rest
}: UseQueryOptions<TQueryFnData, TError, TData>) => {
  const userId = useAuthStore.getState()?.activeSession?.userId || 'anonymous';
  const appLanguage = useRegionStore.getState().appLanguage || 'en';
  const key: QueryKey = [...queryKey, userId, appLanguage];

  return useQuery({
    ...rest,
    queryKey: key,
  });
};
